// REACT
import * as React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR COMPONENTS
import VisibilitySensor from 'react-visibility-sensor';
import CircularProgress from 'material-ui/CircularProgress';
import ThumbUp from 'material-ui/svg-icons/action/thumb-up';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';

// CUSTOM COMPONENTS
import MessageBoxSC from '../Chat/MessageBoxSC';

// VENDOR UTILS
import anchorme from 'anchorme';
import isEqual from 'lodash/isEqual';
const moment = require('moment-timezone');

// Custom Utils
import MessageBackEnd from 'utils/ChatBackend';
const {
    setLogLikedStatus,
    setLogReviewedStatus,
    attachLogComment,
} = MessageBackEnd;
import { toArray } from 'utils/lodashUtils';
import { scrollToBottom } from 'utils/messagingUtils';
import SendMessageButton from '../Button/SendMessageButton';
import MessageSubmitFormSC from '../Chat/MessageSubmitFormSC';
import { constants } from 'constants/index';

class PhotoLogList extends React.Component {
    props; // this is important only for typescript

    panel = {};

    chat = {
        clientHeight: 0,
        scrollHeight: 0,
        scrollTop: 0,
    };
    reviewed = {};
    liked = {};
    comment = {
        parentId: null,
        text: null,
    };

    messages = [];

    constructor(props) {
        super(props);
        this.state = {
            allowedToLoadPrevious: props.allowedToLoadPrevious,
            buttonColor: '#C6CACC',
            count: 0,
            firstScrollPosition: 0,
            keepToBottom: null,
            loadingPrevious: false,
            messages: [],
            messagesLoaded: props.messagesLoaded,
            scrolledToBottom: false,
            userScrolled: false,
        };
    }

    componentDidMount() {
        // Listen for user scroll, if they scroll stop scrolling to bottom
        this.panel.addEventListener('wheel', this.handleWheelScroll, true);

        this.setState(prevState => ({
            keepToBottom: setInterval(() => {
                if (!prevState.userScrolled) {
                    this.scrollToBottom();
                }
            }, 5),
        }));

        // In case they don't scroll stop interval after 5 seconds
        setTimeout(() => {
            clearInterval(this.state.keepToBottom);
            // console.log('CLEAR INTERVAL after 10 seconds');
            if (
                this
                    .panel /* NEEDS TO BE CONDITIONAL IN CASE COMP IS NOT MOUNTED WHEN CALLBACK FIRES */
            ) {
                this.panel.removeEventListener(
                    'wheel',
                    this.handleWheelScroll,
                    true,
                );
            }
        }, 10000);
    }

    componentWillReceiveProps(nextProps) {
        const {
            notificationCounts: prevNotificationCounts,
            selectedService: prevSelectedService,
        } = this.props;
        const {
            notificationCounts: nextNotificationCounts,
            selectedService: nextSelectedService,
        } = nextProps;
        const prevNotificationCountsPerService =
            prevNotificationCounts &&
            prevNotificationCounts[prevSelectedService._id];
        const nextNotificationCountsPerService =
            nextNotificationCounts &&
            nextNotificationCounts[nextSelectedService._id];
        // HIDE NEW BADGE NOTIFICATIONS FOR THIS TAB WHILE THE TAB IS MOUNTED
        if (
            (prevNotificationCountsPerService &&
                nextNotificationCountsPerService &&
                prevNotificationCountsPerService.newNutritionLogCount !==
                    nextNotificationCountsPerService.newNutritionLogCount) ||
            (prevNotificationCountsPerService &&
                nextNotificationCountsPerService &&
                prevNotificationCountsPerService.newNutritionLogReviewCount !==
                    nextNotificationCountsPerService.newNutritionLogReviewCount) ||
            (prevNotificationCountsPerService &&
                nextNotificationCountsPerService &&
                prevNotificationCountsPerService.newNutritionLogCommentCount !==
                    nextNotificationCountsPerService.newNutritionLogCommentCount) ||
            (prevNotificationCountsPerService &&
                nextNotificationCountsPerService &&
                prevNotificationCountsPerService.newNutritionLogLikeCount !==
                    nextNotificationCountsPerService.newNutritionLogLikeCount)
        ) {
            this.handleClearNotifications();
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (
            (this.props.messagesLoaded &&
                prevProps.messagesLoaded === false &&
                !this.state.scrolledToBottom) ||
            ((this.props.messagesRedux && this.props.messagesRedux.length) !==
                (prevProps.messagesRedux && prevProps.messagesRedux.length) &&
                !this.state.scrolledToBottom)
        ) {
            // console.log('SCROLLING TO BOTTOM @ CDU');
            this.scrollToBottom();
            this.setState({
                scrolledToBottom: true,
            });
            // console.log('MESSAGES LOADED @ LIST', this.props.messagesLoaded, prevProps.messagesLoaded, prevProps);
            this.convertLinks();
        }
        if (
            prevProps.shouldScrollToBottom !==
                this.props.shouldScrollToBottom &&
            this.props.shouldScrollToBottom
        ) {
            // Scrolls to bottom that are triggered by parent ChatComponent
            this.scrollToBottom();
            this.props.resetShouldScrollToBottom();
            this.convertLinks();
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (
            this.props.messages &&
            !isEqual(this.props.messages, nextProps.messages)
        ) {
            // console.log('MESSAGE CHANGED, SHOULD UPDATE');
            return true;
        }
        return true;
    };

    handleWheelScroll = e => {
        // console.log('YOU SCROLLED, stopping continuous scroll to bottom');
        this.setState(
            {
                userScrolled: true,
            },
            () => {
                // console.log('USER HAS SCROLLED ', this.state.userScrolled);
                clearInterval(this.state.keepToBottom);
                this.panel.removeEventListener(
                    'wheel',
                    this.handleWheelScroll,
                    true,
                );
                // this.panel.removeEventListener('touchmove', this.handleWheelScroll, true);
                this.props.resetShouldScrollToBottom();
                this.setState({
                    scrolledToBottom: true,
                });
            },
        );
    };

    convertLinks = () => {
        // rce-mbox-text
        const messageNodesObject = document.querySelectorAll('.rce-mbox-text');
        // console.log('ARRAY OF MESSAGE NODES', messageNodesObject);

        messageNodesObject.forEach(messageNode => {
            // console.log('MESSAGE TEXT', messageNode, messageNode.innerText);
            if (
                anchorme.validate.email(messageNode.innerText) ||
                anchorme.validate.url(messageNode.innerText) ||
                anchorme.validate.ip(messageNode.innerText)
            ) {
                messageNode.innerHTML = anchorme(messageNode.innerText, {
                    files: false,
                });
            } else {
                // IGNORE DUE TO SECURITY THREAT - WE NEED TO VALIDATE THE INPUT BEFORE ALLOWING IT TO BE ADDED TO THE HTML - ONLY URLs and EMAILs ALLOWED
            }
        });
    };

    scrollToBottom = () => {
        scrollToBottom(this.chat);
    };

    loadPreviousMessages = isVisible => {
        // console.log('I AM VISIBLE', this.props.messagesRedux.length, this.props.allowedToLoadPrevious)
        if (
            this.props.messagesRedux.length >
            19 /*&& this.props.allowedToLoadPrevious*/
        ) {
            // console.log('IS VISIBLE?', isVisible, this.state.loadingPrevious);
            if (
                !isVisible ||
                /*!this.props.allowedToLoadPrevious ||*/ this.state
                    .loadingPrevious
            ) {
                return null;
            }

            // console.log('COUNT CALC (count/count*19/length/nodeindex)', this.state.count, this.state.count * 19, this.props.messages.length - 1, this.props.messages.length - 1 - (this.state.count * 19));
            // const allmess = document.querySelectorAll(".messages .message");
            // console.log('MESSAGES', allmess );

            this.setState(prevState => {
                return {
                    count: prevState.count + 1,
                    loadingPrevious: true,
                };
            });

            return this.props
                .loadMoreMessages()
                .then(previousMessages => {
                    // console.log('PREV MESS', previousMessages, previousMessages.length, document.querySelectorAll('.messages .message'));

                    let lastLoadedMessage = document.querySelectorAll(
                        '.messages .message',
                    )[previousMessages.length];

                    process.nextTick(() => {
                        lastLoadedMessage.parentNode.scrollTop =
                            lastLoadedMessage.offsetTop -
                            lastLoadedMessage.parentNode.offsetTop;

                        this.convertLinks();
                        return this.setState({
                            loadingPrevious: false,
                        });
                    });
                })
                .catch(console.log);
        }
    };

    onCommentSubmit = e => {
        // SUBMIT COMMENT
        // console.log('Comment Form Submitted:', e.target, e.target.elements["messageText"].value);
        const messageText = 'messageText';
        const messageId = 'messageId';
        const form = e.target;
        let commentTextField = form.elements[messageText];
        const logIdField = form.elements[messageId];

        e.preventDefault();
        if (!commentTextField.value) {
            return false;
        }

        // console.log('PHOTO INPUT VALUE', photoInput.value);
        attachLogComment({
            channel: this.props.channel,
            commentBy: this.props.userData.uid,
            commentText: commentTextField.value,
            createdAt: moment.utc().format('x'),
            logId: logIdField.value,
        });

        commentTextField.value = '';
        logIdField.value = null;

        return true;
    };

    getProviderProfile = providerId => {
        if (this.props.userData.provider) {
            // TODO: this goes over every provider which could be very inefficient at scale, not sure of a work around at the moment
            // console.log('USER DATA', this.props.userData);
            let providerData;
            this.props.providers.map(provider => {
                if (provider.uid === providerId) {
                    providerData = provider;
                    providerData.firstName =
                        provider.name && provider.name.first;
                    providerData.lastName = provider.name && provider.name.last;
                }
            });
            return providerData;
        } else {
            let profileData;

            this.props.providerProfiles.map(profile => {
                if (profile.uid === providerId) {
                    profileData = profile;
                }
            });

            return profileData;
        }
    };

    getProviderLikeStatus = message => {
        if (
            message.likes &&
            [message.likes][0].checkedBy === this.props.userData.uid
        ) {
            return message.likes;
        } else if (
            message.likes &&
            ![message.likes][0].checkedBy &&
            toArray(message.likes).length > 0
        ) {
            const likes = toArray(message.likes).filter(like => {
                // console.log('LIKE', like);

                return like.checkedBy === this.props.userData.uid;
            });
            // console.log('GOT LIKE FOR PROVIDER', likes);

            return likes[0];
        } else {
            return {
                isChecked: false,
            };
        }
    };

    getProviderReviewStatus = message => {
        if (
            message.reviews &&
            [message.reviews][0].checkedBy === this.props.userData.uid
        ) {
            return message.reviews;
        } else if (
            message.reviews &&
            ![message.reviews][0].checkedBy &&
            toArray(message.reviews).length > 0
        ) {
            const reviews = toArray(message.reviews).filter(review => {
                // console.log('Review', review);

                return review.checkedBy === this.props.userData.uid;
            });
            // console.log('GOT REVIEW FOR PROVIDER', reviews);

            return reviews[0];
        } else {
            return {
                isChecked: false,
            };
        }
    };

    handleClearNotifications = () => {
        const {
            userData,
            selectedClient,
            selectedService,
            refreshNotifications,
            getNotificationCounts,
            clearNotifications,
        } = this.props;
        // console.log('HANDLING CLEAR NOTIFICATONS...');
        if (userData && userData.provider) {
            // console.log('CLEARING PROVIDER NOTIFICATIONS...');
            clearNotifications({
                clientId: selectedClient && selectedClient.uid,
                serviceId: selectedService && selectedService._id,
                type: 'newNutritionLog',
                userId: userData && userData.uid,
            })
                .then(() => {
                    // refreshPro();
                })
                .catch(console.log);
        }
        if (userData && !userData.provider) {
            // console.log('CLEARING CONSUMER NOTIFICATIONS...');
            clearNotifications({
                clientId: selectedClient && selectedClient.uid,
                serviceId: selectedService && selectedService._id,
                type: 'newNutritionLogLike',
                userId: userData && userData.uid,
            });

            clearNotifications({
                clientId: selectedClient && selectedClient.uid,
                serviceId: selectedService && selectedService._id,
                type: 'newNutritionLogComment',
                userId: userData && userData.uid,
            });

            clearNotifications({
                clientId: selectedClient && selectedClient.uid,
                serviceId: selectedService && selectedService._id,
                type: 'newNutritionLogReview',
                userId: userData && userData.uid,
            });
        }
    };

    handleSetButtonColor = e => {
        if (e.target.value.length > 0) {
            this.setState({
                buttonColor: '#4AC4D1',
            });
        } else {
            this.setState({
                buttonColor: '#C6CACC',
            });
        }
    };

    renderMessages = messages => {
        const { messagesRedux } = this.props;

        const messageNodes = messagesRedux.map((message, index) => {
            const { userData, channel } = this.props;
            // console.log('LOGS @ PHOTO LOG LIST', message);

            return (
                <div
                    style={{
                        borderRadius: 3,
                        boxShadow: '4px 3px 20px 0px rgba(99, 99, 99, 0.45)',
                        marginLeft: 30,
                        marginRight: 30,
                        marginBottom: 10,
                        marginTop: index === 0 ? 10 : 0,
                    }}
                    key={index}
                >
                    <div
                        ref={node => {
                            this.messages.push(node);
                        }}
                        className="message"
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            maxWidth: '100%',
                            cursor: this.props.userData.provider
                                ? 'pointer'
                                : 'default',
                        }}
                    >
                        {' '}
                        {/* height: this.props.windowHeight */}
                        {userData && !userData.provider && (
                            <div
                                id={'viewedAndLikedOuterContainer'}
                                style={styles.viewedAndLikedOuterContainer}
                            >
                                {!toArray(message.reviews).checkedBy &&
                                    toArray(message.reviews).length > 0 && (
                                        <div
                                            id={'viewedAndLikedInnerContainer'}
                                            style={
                                                styles.viewedAndLikedInnerContainer
                                            }
                                        >
                                            {/* <CheckCircle color={ (message.reviewed && message.reviewed[userData.uid]) ? 'cyan' : 'gray' }/> */}
                                            {!toArray(message.reviews)
                                                .checkedBy &&
                                                toArray(message.reviews)
                                                    .length > 0 &&
                                                toArray(message.reviews)
                                                    .filter(review => {
                                                        if (review.isChecked) {
                                                            return review;
                                                        }
                                                    })
                                                    .map(review => {
                                                        return (
                                                            <Avatar
                                                                src={
                                                                    this.getProviderProfile(
                                                                        review.checkedBy,
                                                                    )
                                                                        .profilePhotoURL
                                                                }
                                                                size={30}
                                                            />
                                                        );
                                                    })}
                                            {((message.reviews &&
                                                message.reviews.isChecked) ||
                                                (message.likes &&
                                                    message.likes
                                                        .isChecked)) /* In case there was only one like */ && (
                                                <Avatar
                                                    src={
                                                        this.getProviderProfile(
                                                            message.reviews
                                                                .checkedBy,
                                                        ).profilePhotoURL
                                                    }
                                                    size={30}
                                                />
                                            )}
                                        </div>
                                    )}
                                {message.likes &&
                                    message.likes.isChecked &&
                                    !toArray(message.likes).checkedBy &&
                                    toArray(message.likes).length > 0 && (
                                        <div
                                            style={
                                                styles.viewedAndLikedInnerContainer
                                            }
                                        >
                                            <ThumbUp
                                                color={
                                                    message.liked &&
                                                    message.liked[userData.uid]
                                                        ? 'yellow'
                                                        : 'gray'
                                                }
                                            />
                                            {!toArray(message.likes)
                                                .checkedBy &&
                                                toArray(message.likes).length >
                                                    0 &&
                                                toArray(message.likes)
                                                    .filter(like => {
                                                        // console.log('LIKE CLIENTSIdE in filter', like);

                                                        if (like.isChecked) {
                                                            return like;
                                                        }
                                                    })
                                                    .map(like => {
                                                        // console.log('LIKE IN MAP', like);

                                                        return (
                                                            <Avatar
                                                                src={
                                                                    this.getProviderProfile(
                                                                        like.checkedBy,
                                                                    )
                                                                        .profilePhotoURL
                                                                }
                                                                size={30}
                                                            />
                                                        );
                                                    })}
                                            {/* In case there was only one like  */}
                                            {!(
                                                message.reviews &&
                                                message.reviews.isChecked
                                            ) &&
                                                (message.likes &&
                                                    message.likes
                                                        .isChecked) && (
                                                    <Avatar
                                                        src={
                                                            this.getProviderProfile(
                                                                message.likes
                                                                    .checkedBy,
                                                            ).profilePhotoURL
                                                        }
                                                        size={30}
                                                    />
                                                )}
                                        </div>
                                    )}
                            </div>
                        )}
                        {userData && userData.provider && (
                            <div
                                id={'viewedAndLikedOuterContainer'}
                                style={styles.viewedAndLikedOuterContainer}
                            >
                                {this.getProviderReviewStatus(message)
                                    .isChecked && (
                                    <div
                                        id={'viewedAndLikedInnerContainer'}
                                        style={
                                            styles.viewedAndLikedInnerContainer
                                        }
                                    >
                                        {/* <p>LIKED: {JSON.stringify(this.getProviderLikeStatus(message).isChecked)}</p> */}
                                        <label
                                            disabled={!userData.provider}
                                            htmlFor={`liked-${index}`}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <ThumbUp
                                                color={
                                                    this.getProviderLikeStatus(
                                                        message,
                                                    ).isChecked
                                                        ? 'yellow'
                                                        : 'gray'
                                                }
                                            />
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={`liked-${index}`}
                                            style={{ display: 'none' }}
                                            checked={
                                                this.getProviderLikeStatus(
                                                    message,
                                                ).isChecked
                                            }
                                            onChange={() => {
                                                const liked = document.getElementById(
                                                    `liked-${index}`,
                                                );
                                                // console.log('LIKED', liked.checked);

                                                setLogLikedStatus({
                                                    channel: channel,
                                                    checkedBy: userData.uid,
                                                    isChecked: liked.checked,
                                                    logId: message._id,
                                                });
                                            }}
                                        />
                                    </div>
                                )}
                                <div
                                    id={'viewedAndLikedInnerContainer'}
                                    style={styles.viewedAndLikedInnerContainer}
                                >
                                    {/* <p>REVIEWED: {JSON.stringify(this.getProviderReviewStatus(message).isChecked)}</p> */}
                                    <label
                                        disabled={!userData.provider}
                                        htmlFor={`reviewed-${index}`}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <CheckCircle
                                            color={
                                                this.getProviderReviewStatus(
                                                    message,
                                                ).isChecked
                                                    ? 'cyan'
                                                    : 'gray'
                                            }
                                        />
                                    </label>
                                    {/* { message.reviews && message.reviews.isChecked && (this.getProviderReviewStatus(message).isChecked) && 
                                        <Avatar
                                            src={this.getProviderProfile(message.likes.checkedBy).profilePhotoURL}
                                            size={30}
                                        />
                                    } */}
                                    {!this.getProviderReviewStatus(message)
                                        .isChecked && (
                                        <input
                                            // ref={
                                            //     reviewed => this.reviewed[index].checked = (message.reviewed) ? message.reviewed[this.props.userData.uid] : false
                                            // }
                                            type="checkbox"
                                            id={`reviewed-${index}`}
                                            // value={(message.reviewed) ? message.reviewed[this.props.userData.uid] : false}
                                            checked={
                                                this.getProviderReviewStatus(
                                                    message,
                                                ).isChecked
                                            }
                                            onChange={() => {
                                                const reviewed = document.getElementById(
                                                    `reviewed-${index}`,
                                                );
                                                // console.log('REVIEWED', reviewed.checked);
                                                setLogReviewedStatus({
                                                    channel: channel,
                                                    checkedBy: userData.uid,
                                                    isChecked: reviewed.checked,
                                                    logId: message._id,
                                                });
                                            }}
                                            style={{ display: 'none' }}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        <MessageBoxSC
                            type={message.photoURL ? 'photo' : 'text'}
                            title={
                                message.mealTitle
                                    ? message.mealTitle.toUpperCase()
                                    : null
                            }
                            text={message.mealDescription}
                            data={{
                                alt: 'Photo log entry',
                                status: {
                                    click: true,
                                    loading: 0,
                                },
                                uri: message.photoURL,
                            }}
                            date={moment(message.createdAt, 'x').local()} // pass
                            className={
                                message.senderId === this.props.userData.uid
                                    ? 'sender'
                                    : 'receiver'
                            } // this can be used to style the send and receiver differently in the custom css file
                            notch={
                                false /* ONLY SHOW NOTCH IF THE LAST ID IS NOT YOURS OR THERE IS NOT MESSAGE BEFORE (MESSAGES IS index 0*/
                            }
                            onClick={() => {
                                // alert('dfsdf')
                            }}
                            css={`
                                 {
                                    display: flex;
                                    flex-direction: column;
                                }
                            `}
                        />
                    </div>
                    <List>
                        {message.comments &&
                            toArray(message.comments).map((comment, i) => {
                                // console.log('PROVIDER COMMENTS', comment);
                                return (
                                    <div key={i}>
                                        <ListItem
                                            disabled={true}
                                            leftAvatar={
                                                <Avatar
                                                    src={
                                                        this.getProviderProfile(
                                                            comment.commentBy,
                                                        ).profilePhotoURL
                                                    }
                                                    size={30}
                                                    // style={style}
                                                />
                                            }
                                            // rightIcon={}
                                            primaryText={
                                                this.getProviderProfile(
                                                    comment.commentBy,
                                                ).firstName +
                                                ' ' +
                                                this.getProviderProfile(
                                                    comment.commentBy,
                                                ).lastName
                                            }
                                            secondaryText={
                                                <div
                                                    style={{
                                                        height: 'auto',
                                                        textOverflow: 'wrap',
                                                        whiteSpace: 'wrap',
                                                    }}
                                                >
                                                    {`${comment.commentText}`}
                                                    <span>{` (${moment(
                                                        comment.createdAt,
                                                        'x',
                                                    )
                                                        .local()
                                                        .fromNow()})`}</span>
                                                </div>
                                            }
                                        />
                                        {/* <p>- {comment.commentText} <span style={{ color: 'gray', fontSize: 12 }}>({moment(comment.createdAt, 'x').local().fromNow()})</span></p> */}
                                    </div>
                                );
                            })
                        // JSON.stringify(message.comments && message.comments[userData.uid])
                        }
                    </List>
                    {userData && userData.provider && (
                        <div>
                            <form
                                onSubmit={e => this.onCommentSubmit(e)}
                                style={styles.commentFormStyles}
                            >
                                <div style={{ paddingLeft: 9 }}>
                                    <label
                                        style={{ cursor: 'pointer' }}
                                        htmlFor={`submit-${index}`}
                                    >
                                        <SendMessageButton
                                            buttonBackgroundColor={
                                                this.state.buttonColor
                                            }
                                        />
                                    </label>
                                    <input
                                        style={{ display: 'none' }}
                                        id={`submit-${index}`}
                                        type="submit"
                                    />
                                </div>
                                <input
                                    onKeyUp={this.handleSetButtonColor}
                                    ref={comment => {
                                        // console.log('COMMENT', (comment && comment.value));
                                        this.comment.text = comment;
                                    }}
                                    name="messageText"
                                    type="text"
                                    placeholder="Comment on this photo..."
                                    style={styles.commentInputStyles}
                                />

                                <input
                                    onKeyUp={this.handleSetButtonColor}
                                    ref={mId => (this.comment.parentId = mId)}
                                    name="messageId"
                                    type="hidden"
                                    value={message._id}
                                />
                            </form>
                        </div>
                    )}
                </div>
            );
        });

        return messageNodes;
    };

    render() {
        // const inputField = this.props.hasInputField && <ChatInput />;
        const { maxHeight, messagesRedux, isModulePartOfService } = this.props;

        return (
            <div
                ref={panel => (this.panel = panel)}
                id="chat-panel"
                style={styles.chatPanel}
            >
                <div
                    ref={node => {
                        this.chat = node;
                    }}
                    className="messages"
                    style={{ ...styles.chatHistory, maxHeight }}
                >
                    {messagesRedux &&
                        messagesRedux.length > 19 &&
                        this.props.loadMoreMessages && (
                            <div
                                style={{
                                    marginBottom: 20,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                {/* <Spinner /> */}
                                <VisibilitySensor
                                    delay={0}
                                    containment={this.chat}
                                    delayedCall={true}
                                    partialVisibility={true}
                                    active={!this.state.loadingPrevious}
                                    // onChange={ this.loadPreviousMessages }
                                >
                                    {({ isVisible }) => {
                                        if (isVisible) {
                                            this.loadPreviousMessages(
                                                isVisible,
                                            );
                                        }
                                        return (
                                            <CircularProgress
                                                size={40}
                                                thickness={5}
                                            />
                                        );
                                    }}
                                </VisibilitySensor>
                            </div>
                        )}
                    {messagesRedux &&
                        messagesRedux.length > 0 &&
                        this.renderMessages(this.props.messagesRedux)}
                    {this.props.isUploading && (
                        <div
                            className="uploadingSpinner"
                            style={{
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                margin: '10px 30px',
                                justifyContent: 'center',
                                padding: '10px 40px',
                                height: 430,
                                alignItems: 'center',
                                backgroundColor: 'rgba(50,50,50,0.1)',
                                borderRadius: '10px',
                            }}
                        >
                            <div>
                                <CircularProgress size={300} thickness={230} />
                            </div>
                            <div
                                style={{
                                    height: 0,
                                    position: 'relative',
                                    top: -220,
                                    textAlign: 'center',
                                }}
                            >
                                <p
                                    style={{
                                        fontFamily: 'Open Sans',
                                        fontSize: 30,
                                        marginBottom: -10,
                                    }}
                                >
                                    Uploading...
                                </p>
                                <span
                                    style={{
                                        fontSize: 12,
                                        color: 'rgba(0,0,0,0.5)',
                                    }}
                                >
                                    (large photos may take a while)
                                </span>
                                <br />
                            </div>
                        </div>
                    )}
                    {
                        <VisibilitySensor
                            delay={0}
                            containment={document.querySelector('.messages')}
                            // delayedCall={true}
                            partialVisibility={true}
                            // active={!this.state.loadingPrevious}
                            onChange={this.handleClearNotifications}
                        />
                    }
                    {messagesRedux &&
                    messagesRedux.length === 0 && ( // TODO: style me!
                            <React.Fragment>
                                {isModulePartOfService && (
                                    <p style={styles.noLogsNoticeStyles}>
                                        {this.props.userData.provider
                                            ? 'This client has not sent any progress photos for you to review yet.'
                                            : 'There are no photos logged yet for this service'}
                                    </p>
                                )}
                                {!isModulePartOfService && (
                                    <p
                                        style={{
                                            ...styles.noLogsNoticeStyles,
                                            textAlign: 'center',
                                            fontSize: 14,
                                            color: 'darkgray',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Sending progress photos for assessment
                                        is not available for this service.
                                    </p>
                                )}
                            </React.Fragment>
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    chat,
    provider,
    client,
    notification,
    photoLog,
}) => {
    // console.log('MESSAGES FROM REDUX @ photologlist', chat.logMessages, client.clientData.providerProfiles);
    // console.log('PROVIDERS @ loglist', client.clientData.providerProfiles); //get providers from clientDAta to show avatrars

    return {
        isUploading: photoLog.isUploading,

        messagesRedux: chat.logMessages,
        providerProfiles: client.clientData.providerProfiles, // only accessible from client view of logs
        providers: provider.providers,

        // NOTIFICATION PROPS
        newNutritionLogComments:
            notification.notifications.nutritionLogComments,
        newNutritionLogLikes: notification.notifications.nutritionLogLikes,
        newNutritionLogReviews: notification.notifications.nutritionLogReviews,
        newNutritionLogs: notification.notifications.nutritionLogs,
        userData: client.clientData,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(PhotoLogList);

const styles = {
    chatHistory: {
        overflow: 'auto',
    },
    chatPanel: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    commentFormStyles: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 15,
    },
    commentInputStyles: {
        border: 'none',
        fontSize: '16px',
        padding: '10px',
        width: 'calc(100% - 50px)',
    },
    viewedAndLikedInnerContainer: {
        paddingRight: 10,
    },
    viewedAndLikedOuterContainer: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        padding: 10,
    },
    noLogsNoticeStyles: {
        paddingTop: '50%',
        fontSize: constants.text.baseFontStyles.fontSize,
        textAlign: 'center',
    },
};



// WEBPACK FOOTER //
// ./src/js/components/PhotoLogs/PhotoLogList.jsx